enum DataExportStatusConstants {
  UNDEFINED = 'UNDEFINED',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_SLOW = 'IN_PROGRESS_SLOW',
  CREATED = 'CREATED',
  ERROR = 'ERROR',
}

export default DataExportStatusConstants;
